<template>
  <div
    class="avatar"
    :class="{
      avatar__bordered: border,
      avatar__orange: userNotHasAvatar,
    }"
    :style="avatarSize"
  >
    <img v-if="emptyUser" src="/img/icons/no-avatar-grayscale.svg" alt="no-avatar">
    <!--    <img v-else-if="userNotHasAvatar" src="/img/icons/no-avatar-color.svg" alt="no-avatar">-->
    <div v-else-if="userNotHasAvatar" class="no-avatars-letters">
      {{ shortNameLetters }}
    </div>
    <img v-else :src="user.imageUrl" alt="avatar">
  </div>
</template>

<script>
  export default {
    name: 'Avatar',
    props: {
      user: null,
      size: {
        type: Number,
        default: null,
      },
      border: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      avatarSize () {
        if (this.size) {
          return {
            width: `${this.size}px`,
            height: `${this.size}px`,
          }
        }
        return null
      },
      emptyUser () {
        return !this.user?.id
      },
      userNotHasAvatar () {
        return !this.user?.imageUrl
      },
      shortNameLetters () {
        let label = ''
        if (this.user?.lastName) {
          label += this.user.lastName.charAt(0).toUpperCase()
        }
        if (this.user?.firstName) {
          label += this.user.firstName.charAt(0).toUpperCase()
        }
        return label
      },
    },
  }
</script>

<style lang="less" scoped>
.avatar {
  width: 50px;
  height: 50px;
  background-color: #00000008;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cfcfcf;

  &__bordered {
    border: 4px solid #fff;
  }

  &__orange {
    background: #FF9100;
    border: 4px solid #FF9100;
  }

  &__no_border {
    border: 4px solid transparent;
  }

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  svg {
    width: 100%;
    height: 100%;
  }

  /* &:nth-child(2) {
     margin-top: 10px;
   }*/

  .no-avatars-letters {
    color: white;
    font-weight: bold;
    font-size: 18px;
  }
}
</style>
